import ReactGA4 from 'react-ga4';

export const sendPath = path => {
  return ReactGA4.send({hitType: 'pageview', page: path});
};

export const sendEvent = (category, action) => {
  return ReactGA4.event({category: category, action: action});
};
